// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__7smXE","range":"MonthRangeSwitch_range__2iJhr","disabled":"MonthRangeSwitch_disabled__10JyY"};